import axios from 'axios';

// ---------------------------------------------------------------------------------------------------------------------

const AXIOS_INSTANCE = axios.create({
  baseURL: process.env.REACT_APP_ROAMING_BASE_URL?.replace('{origin}', window.location.origin) ?? undefined,
  timeout: 0,
});

// ---------------------------------------------------------------------------------------------------------------------

export const fetchCountries = (config = {}) => {
  return AXIOS_INSTANCE.get(process.env.REACT_APP_ROAMING_COUNTRIES, config);
};

export const fetchCountryProviders = (countryId, customerType) => {
  return AXIOS_INSTANCE.get(process.env.REACT_APP_ROAMING_PROVIDERS, {
    params: {
      countryId,
      customerType,
    },
  });
};

export const fetchProductsSummary = (config = {}) => {
  return AXIOS_INSTANCE.get(process.env.REACT_APP_ROAMING_PRODUCTS, config);
};

// ---------------------------------------------------------------------------------------------------------------------
